{
    "LogFileDownload_DownloadTitle": "Télécharger **{}**",
    "LogFileDownload_HowManyFiles": "Combien de fichiers précédents souhaitez-vous télécharger ?",
    "LogFileDownload_AllFiles": "Tous les fichiers",
    "LogFileDownload_NFile": "{} fichier(s) passé(s)",
    "LogFileDownload_CurrentFile": "Fichier actuel",
    "NAME": "LanguageLogFileDownload"
}